@use '@lib/assets/styles/main.scss' as *;

.listWrap {
  margin-bottom: 16px;
}

.list {
  border-radius: 6px;
  border: 1px solid $gray200;
  background: $gray0;
  overflow: hidden;
  position: relative;
  transition: border .3s ease;
  &.listWithError {
    border-color: $error900;
  }
}

.listScroll {
  @include scrollStyles;
  overflow-y: auto;
  max-height: 480px;
  margin-bottom: -2px;
}

.gradient {
  background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%);
  height: 40px;
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 2;
}

.header {
  display: grid;
  grid-template-columns: minmax(0, auto) min-content min-content;
  grid-gap: 16px;
  align-items: center;
  margin-bottom: 16px;
  white-space: nowrap;
}

.headerTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.headerDesc {
  color: $gray500;
}

.infoBoxIcon {
  display: block;
  color: $gray500;
  cursor: pointer;
}

.listItem {
  border-top: 1px solid $gray200;
  border-bottom: 1px solid $gray200;
  margin-top: -1px;
  position: relative;
  &.listItemWithError {
    border-color: $error900;
    z-index: 1;
  }
  &.listItemHidden {
    visibility: hidden;
    position: absolute;
    left: -100vw;
    top: -100vw;
  }
}

.listRow {
  display: grid;
  grid-template-columns: 60px minmax(0, auto);
  align-items: center;
}

.listItemWithDeleteBtn {
  display: grid;
  grid-template-columns: minmax(0, auto) 48px;
}

.listItemIndex {
  padding: 8px 8px 8px 16px;
  background-color: $gray10;
  line-height: 32px;
  transition: background-color .3s ease;
  .listItemWithError & {
    background-color: $error100;
  }
}

.listItemDelete {
  width: 48px;
  display: flex;
  justify-content: center;
}

.formItem {
  padding: 0;
}
